import { useQuery } from 'react-query';

import { PublicApplicationAPI } from '@lib/api/endpoints/Applications';

export const useGetJobsBoardLocationsPublic = (
  searchTerm: string | null | undefined,
  publicCountry: ProductionCountry
) => {
  const trimmedSearchTerm = searchTerm?.trim() || '';

  const { data, isLoading, isError } = useQuery({
    queryKey: ['jobsBoardLocationsPublic', trimmedSearchTerm, publicCountry],
    queryFn: () =>
      PublicApplicationAPI.getJobsBoardLocationsPublic(
        trimmedSearchTerm,
        publicCountry
      ),
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isLoading,
    isError,
  };
};
